import React, { useEffect, useContext, ReactElement, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectCreditApplication } from 'state/creditApplication';
import { resetApplication } from 'state/resetApplication';
import useQueryParameters from 'hooks/useQueryParameters';

export interface CachedAttributes {
  applicantEmail: string | null;
  storeNumber: string | null;
  cardChoice: number | null;
}

export const CachedAttributesContext = React.createContext<CachedAttributes>({
  applicantEmail: null,
  storeNumber: null,
  cardChoice: null,
});

export const useCachedAttribute: () => CachedAttributes = () => {
  return useContext(CachedAttributesContext);
};

const ResetApplicationRoute: React.FC = ({ children }) => {
  const { emailAddress, storeNumber: appStoreNumber, cardChoice } = useSelector(
    selectCreditApplication,
  );

  const { storeNumber: queryStoreNumber } = useQueryParameters();

  const dispatch = useDispatch();

  const [cachedAttributes] = useState<CachedAttributes>({
    applicantEmail: emailAddress,
    storeNumber: queryStoreNumber || appStoreNumber,
    cardChoice: cardChoice,
  });

  useEffect(() => {
    dispatch(resetApplication());
  }, [dispatch]);

  return (
    <>
      <CachedAttributesContext.Provider value={cachedAttributes}>
        {React.Children.map(children, child =>
          React.cloneElement(child as ReactElement),
        )}
      </CachedAttributesContext.Provider>
    </>
  );
};

export default ResetApplicationRoute;
